// extracted by mini-css-extract-plugin
module.exports = {"CreatePost":"CreatePost_CreatePost__2IYkO","Header":"CreatePost_Header__2ioCn","Content":"CreatePost_Content__wNGCa","Footer":"CreatePost_Footer__2SiqC"};